// Money as the Settlement tab prints it: storage-precision decimal strings in,
// statement-style figures out. Shared by the settlement view utils and the Net
// payout tile so the two can never round differently.
import { SETTLEMENT_EMPTY_VALUE } from '../constants/propertySettlement'

// Statement-style: always two decimals. A fee line reading "48,000" next to
// "1,150.50" looks like rounding; the design prints every figure to the cent.
const STATEMENT_AMOUNT = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function numberOf(value: string | null): number | null {
  if (value === null || value.trim() === '') return null
  const amount = Number(value)
  return Number.isFinite(amount) ? amount : null
}

export function formatStatementAmount(value: string | null): string {
  const amount = numberOf(value)
  return amount === null ? SETTLEMENT_EMPTY_VALUE : STATEMENT_AMOUNT.format(amount)
}

export function formatStatementMoney(currency: string, value: string | null): string {
  const amount = numberOf(value)
  return amount === null ? SETTLEMENT_EMPTY_VALUE : `${currency} ${STATEMENT_AMOUNT.format(amount)}`
}

export function formatDeduction(currency: string, value: string | null): string {
  const money = formatStatementMoney(currency, value)
  return money === SETTLEMENT_EMPTY_VALUE ? money : `− ${money}`
}

// "50.00" → "50%", "33.33" → "33.33%".
export function formatSharePercent(value: string): string {
  const share = numberOf(value)
  return share === null ? SETTLEMENT_EMPTY_VALUE : `${Number(share.toFixed(2))}%`
}

export function sumOf(...values: Array<string | null>): string | null {
  if (values.every((value) => numberOf(value) === null)) return null
  return String(values.reduce((total, value) => total + (numberOf(value) ?? 0), 0))
}
